import { render, staticRenderFns } from "./DashboardNominas.vue?vue&type=template&id=876b5e14&scoped=true"
import script from "./DashboardNominas.vue?vue&type=script&lang=js"
export * from "./DashboardNominas.vue?vue&type=script&lang=js"
import style0 from "./DashboardNominas.vue?vue&type=style&index=0&id=876b5e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876b5e14",
  null
  
)

export default component.exports